/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import {
  Grid,
  MenuItem,
  TextField,
  Card,
  CardHeader,
  Typography,
  Divider,
  CardContent,
} from "@material-ui/core";
import HomeIcon from "@material-ui/icons/Home";
import { Controller } from "react-hook-form";

import {
  getProvince,
  getCity,
  getDistrict,
  getVillage,
} from "../../../../store/actions";
import { isEmpty } from "../../../../shared/utility";

const useStyles = makeStyles((theme) => ({
  gridPadding: {
    padding: theme.spacing(0, 2, 2, 2),
  },
  field: {
    marginTop: theme.spacing(1),
  },
  card: {
    margin: theme.spacing(5, 1.25, 1.25),
  },
  cardTitle: {
    display: "flex",
    alignItems: "center",
  },
  iconTitle: {
    margin: theme.spacing(0, 1, 0, 2),
  },
}));

const AlamatKTP = (props) => {
  const {
    getProvince,
    getCity,
    getDistrict,
    getVillage,
    register,
    control,
    errors,
    address,
    value,
    setValue,
  } = props;
  const classes = useStyles();

  useEffect(() => {
    if (isEmpty(address.province)) {
      getProvince();
    }
  }, []);

  const handleProvince = (e) => {
    setValue((prev) => ({ ...prev, province: e }));
    const index = address.province.findIndex((x) => x.name === e);
    getCity(address.province[index].id);
  };

  const handleCity = (e) => {
    setValue((prev) => ({ ...prev, city: e }));
    const index = address.city.findIndex((x) => x.name === e);
    getDistrict(address.city[index].id);
  };

  const handleDistrict = (e) => {
    setValue((prev) => ({ ...prev, district: e }));
    const index = address.district.findIndex((x) => x.name === e);
    getVillage(address.district[index].id);
  };

  return (
    <Card className={classes.card}>
      <CardHeader
        title={
          <div className={classes.cardTitle}>
            <HomeIcon className={classes.iconTitle} />
            <Typography variant="h4">Alamat KTP</Typography>
          </div>
        }
      />
      <Divider />
      <CardContent>
        <Grid container>
          <Grid item xs={6} className={classes.gridPadding}>
            {/* Provinsi */}
            <Controller
              control={control}
              name="province_ktp"
              defaultValue=""
              render={({ onChange, ref }) => (
                <TextField
                  fullWidth
                  select
                  label="Provinsi"
                  inputRef={ref}
                  value={value.province}
                  onChange={(e) => {
                    onChange(e.target.value);
                    handleProvince(e.target.value);
                  }}
                  disabled={address.loadingProvince}
                  error={!!errors.province_ktp}
                  helperText={
                    !!errors.province_ktp && errors.province_ktp.message
                  }
                >
                  <MenuItem value="" disabled></MenuItem>
                  {address.province.map((value) => (
                    <MenuItem value={value.name} key={value.id}>
                      {value.name}
                    </MenuItem>
                  ))}
                  {value.province !== "" && isEmpty(address.province) ? (
                    <MenuItem value={value.province}>{value.province}</MenuItem>
                  ) : null}
                </TextField>
              )}
            />

            {/* Kecamatan */}
            <Controller
              control={control}
              name="district_ktp"
              defaultValue=""
              render={({ onChange, ref }) => (
                <TextField
                  className={classes.field}
                  fullWidth
                  select
                  label="Kecamatan"
                  inputRef={ref}
                  value={value.district}
                  onChange={(e) => {
                    onChange(e.target.value);
                    handleDistrict(e.target.value);
                  }}
                  disabled={address.loadingDistrict}
                  error={!!errors.district_ktp}
                  helperText={
                    !!errors.district_ktp && errors.district_ktp.message
                  }
                >
                  <MenuItem value="" disabled></MenuItem>
                  {address.district.map((value) => (
                    <MenuItem value={value.name} key={value.id}>
                      {value.name}
                    </MenuItem>
                  ))}
                  {value.district !== "" && isEmpty(address.district) ? (
                    <MenuItem value={value.district}>{value.district}</MenuItem>
                  ) : null}
                </TextField>
              )}
            />
            <TextField
              className={classes.field}
              type="number"
              fullWidth
              name="postal_code_ktp"
              label="Kode Pos"
              value={value.postal_code}
              onChange={(e) =>
                setValue((prev) => ({ ...prev, postal_code: e.target.value }))
              }
              inputRef={register}
              error={!!errors.postal_code_ktp}
              helperText={
                !!errors.postal_code_ktp && errors.postal_code_ktp.message
              }
            />
          </Grid>
          <Grid item xs={6} className={classes.gridPadding}>
            {/* Kota/Kabupaten */}
            <Controller
              control={control}
              name="city_ktp"
              defaultValue=""
              render={({ onChange, ref }) => (
                <TextField
                  fullWidth
                  select
                  label="Kota/Kabupaten"
                  inputRef={ref}
                  defaultValue=""
                  value={value.city}
                  onChange={(e) => {
                    onChange(e.target.value);
                    handleCity(e.target.value);
                  }}
                  disabled={address.loadingCity}
                  error={!!errors.city_ktp}
                  helperText={!!errors.city_ktp && errors.city_ktp.message}
                >
                  <MenuItem value="" disabled></MenuItem>
                  {address.city.map((value) => (
                    <MenuItem value={value.name} key={value.id}>
                      {value.name}
                    </MenuItem>
                  ))}
                  {value.city !== "" && isEmpty(address.city) ? (
                    <MenuItem value={value.city}>{value.city}</MenuItem>
                  ) : null}
                </TextField>
              )}
            />

            {/* Kelurahan */}
            <Controller
              control={control}
              name="sub_district_ktp"
              defaultValue=""
              render={({ onChange, ref }) => (
                <TextField
                  className={classes.field}
                  fullWidth
                  select
                  label="Kelurahan"
                  inputRef={ref}
                  defaultValue=""
                  value={value.village}
                  onChange={(e) => {
                    onChange(e.target.value);
                    setValue((prev) => ({ ...prev, village: e.target.value }));
                  }}
                  disabled={address.loadingVillage}
                  error={!!errors.sub_district_ktp}
                  helperText={
                    !!errors.sub_district_ktp && errors.sub_district_ktp.message
                  }
                >
                  <MenuItem value="" disabled></MenuItem>
                  {address.village.map((value) => (
                    <MenuItem value={value.name} key={value.id}>
                      {value.name}
                    </MenuItem>
                  ))}
                  {value.village !== "" && isEmpty(address.village) ? (
                    <MenuItem value={value.village}>{value.village}</MenuItem>
                  ) : null}
                </TextField>
              )}
            />
          </Grid>
          <Grid item xs={12} className={classes.gridPadding}>
            <TextField
              className={classes.field}
              fullWidth
              multiline
              rows={5}
              variant="outlined"
              name="street_ktp"
              label="Alamat Lengkap"
              value={value.street}
              onChange={(e) =>
                setValue((prev) => ({ ...prev, street: e.target.value }))
              }
              inputRef={register}
              error={!!errors.street_ktp}
              helperText={!!errors.street_ktp && errors.street_ktp.message}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

const mapStateToProps = (state) => {
  return {
    address: state.address,
  };
};

export default connect(mapStateToProps, {
  getProvince,
  getCity,
  getDistrict,
  getVillage,
})(AlamatKTP);
